import { render, staticRenderFns } from "./UserModal.vue?vue&type=template&id=f5fb751c&scoped=true"
import script from "./UserModal.vue?vue&type=script&lang=js"
export * from "./UserModal.vue?vue&type=script&lang=js"
import style0 from "./UserModal.vue?vue&type=style&index=0&id=f5fb751c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fb751c",
  null
  
)

export default component.exports